// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__qOmGD","buttons":"RemoveExpirationActionButtons_buttons__1of8e"};